<div scId="SC1518" class="page-title filter-sort-component-task">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-8">
        <h2 class="m-t-xl">{{ reviewsStaticContent?.readReviews }}</h2>
        <p class="lead m-t-xs m-b-md">{{ selectedDevicefamilyName }}</p>
      </div>
      <div class="col-12 col-md-4 p-0">
        <div class="filter-sort-container">
          <div
            class="row tertiaty-buttons task m-t-md"
            [class.panel-open]="searchPanelShow || filterPanelShow || sortPanelShow || false"
          >
            <div class="button-box small col-4">
              <a
                href="javascript:void(0);"
                attr.aria-expanded="{{ searchPanelShow || false }}"
                [ngClass]="{ open: searchPanelShow }"
                (click)="
                  searchPanelShow = !searchPanelShow; filterPanelShow = false; sortPanelShow = false
                "
                attr.aria-label="{{ reviewsStaticContent?.search }}"
                id="cta-search-2"
              >
                <span class="center">
                  <i class="fa fa-search"></i>
                  <br />{{ reviewsStaticContent?.search }}</span
                >
              </a>
            </div>
            <div class="button-box small col-4">
              <a
                href="javascript:void(0);"
                attr.aria-expanded="{{ filterPanelShow || false }}"
                [ngClass]="{ open: filterPanelShow }"
                (click)="
                  filterPanelShow = !filterPanelShow; sortPanelShow = false; searchPanelShow = false
                "
                attr.aria-label="{{ reviewsStaticContent?.filter }}"
                id="cta-filter-6"
              >
                <span class="center">
                  <i class="fa fa-filter"></i>
                  <br />{{ reviewsStaticContent?.filter }}</span
                >
              </a>
            </div>
            <div class="button-box small col-4">
              <a
                href="javascript:void(0);"
                attr.aria-expanded="{{ sortPanelShow || false }}"
                [ngClass]="{ open: sortPanelShow }"
                (click)="
                  sortPanelShow = !sortPanelShow; filterPanelShow = false; searchPanelShow = false
                "
                attr.aria-label="{{ reviewsStaticContent?.sort }}"
                id="cta-sort-10"
              >
                <span class="center">
                  <i class="fa fa-sort"></i>
                  <br />{{ reviewsStaticContent?.sort }}</span
                >
              </a>
            </div>
          </div>
          <div class="filter-panel" [hidden]="!filterPanelShow">
            <div class="inner-panel">
              <label class="form-label">
                <tmo-checkbox
                  (onClick)="setFilterByRating($event, 5)"
                  [id]="'tmo-checkbox-default-11'"
                >
                  <span class="rating-select inline-block">
                    <tmo-star-rating [rating]="5" [showMiniStar]="true"></tmo-star-rating>
                  </span>
                  <span>({{ filterData?.closeFilter?.fiveStarCounts || 0 }})</span>
                </tmo-checkbox>
              </label>
              <label class="form-label m-t-md">
                <tmo-checkbox
                  (onClick)="setFilterByRating($event, 4)"
                  [id]="'tmo-checkbox-default-12'"
                >
                  <span class="rating-select inline-block">
                    <tmo-star-rating [rating]="4" [showMiniStar]="true"></tmo-star-rating>
                  </span>
                  <span>({{ filterData?.closeFilter?.fourStarCounts || 0 }})</span>
                </tmo-checkbox>
              </label>
              <label class="form-label m-t-md">
                <tmo-checkbox
                  (onClick)="setFilterByRating($event, 3)"
                  [id]="'tmo-checkbox-default-13'"
                >
                  <span class="rating-select inline-block">
                    <tmo-star-rating [rating]="3" [showMiniStar]="true"></tmo-star-rating>
                  </span>
                  <span>({{ filterData?.closeFilter?.threeStarCounts || 0 }})</span>
                </tmo-checkbox>
              </label>
              <label class="form-label m-t-md">
                <tmo-checkbox
                  (onClick)="setFilterByRating($event, 2)"
                  [id]="'tmo-checkbox-default-14'"
                >
                  <span class="rating-select inline-block">
                    <tmo-star-rating [rating]="2" [showMiniStar]="true"></tmo-star-rating>
                  </span>
                  <span>({{ filterData?.closeFilter?.twoStarCounts || 0 }})</span>
                </tmo-checkbox>
              </label>
              <label class="form-label m-t-md">
                <tmo-checkbox
                  (onClick)="setFilterByRating($event, 1)"
                  [id]="'tmo-checkbox-default-15'"
                >
                  <span class="rating-select inline-block">
                    <tmo-star-rating [rating]="1" [showMiniStar]="true"></tmo-star-rating>
                  </span>
                  <span>({{ filterData?.closeFilter?.oneStarCounts || 0 }})</span>
                </tmo-checkbox>
              </label>
            </div>
          </div>
          <div class="sort-panel" [hidden]="!sortPanelShow">
            <div class="inner-panel">
              <label class="form-label m-t-md">
                <tmo-radio-button
                  class="m-r-l"
                  [selectedValue]="selectedSort"
                  [values]="reviewsStaticContent?.mostHelpfulValue"
                  (onSelect)="sortByReviews(reviewsStaticContent?.mostHelpfulKey)"
                  [id]="'tmo-radio-button-default-18'"
                >
                  <p class="content small">{{ reviewsStaticContent?.mostHelpful }}</p>
                </tmo-radio-button>
              </label>
              <label class="form-label m-t-md">
                <tmo-radio-button
                  class="m-r-l"
                  [selectedValue]="selectedSort"
                  [values]="reviewsStaticContent?.highestRatingValue"
                  (onSelect)="sortByReviews(reviewsStaticContent?.highestRatingKey)"
                  [id]="'tmo-radio-button-default-19'"
                >
                  <p class="content small">{{ reviewsStaticContent?.highestRating }}</p>
                </tmo-radio-button>
              </label>
              <label class="form-label m-t-md">
                <tmo-radio-button
                  class="m-r-l"
                  [selectedValue]="selectedSort"
                  [values]="reviewsStaticContent?.lowestRatingValue"
                  (onSelect)="sortByReviews(reviewsStaticContent?.lowestRatingKey)"
                  [id]="'tmo-radio-button-default-20'"
                >
                  <p class="content small">{{ reviewsStaticContent?.lowestRating }}</p>
                </tmo-radio-button>
              </label>
              <label class="form-label m-t-md">
                <tmo-radio-button
                  class="m-r-l"
                  [selectedValue]="selectedSort"
                  [values]="reviewsStaticContent?.newest"
                  (onSelect)="sortByReviews(reviewsStaticContent?.newest)"
                  [id]="'tmo-radio-button-default-21'"
                >
                  <p class="content small">{{ reviewsStaticContent?.newest }}</p>
                </tmo-radio-button>
              </label>
              <label class="form-label m-t-md">
                <tmo-radio-button
                  class="m-r-l"
                  [selectedValue]="selectedSort"
                  [values]="reviewsStaticContent?.oldest"
                  (onSelect)="sortByReviews(reviewsStaticContent?.oldest)"
                  [id]="'tmo-radio-button-default-22'"
                >
                  <p class="content small">{{ reviewsStaticContent?.oldest }}</p>
                </tmo-radio-button>
              </label>
            </div>
          </div>
          <div class="search-panel" [hidden]="!searchPanelShow">
            <div class="inner-panel">
              <div class="search-box-go">
                <tmo-input
                  [type]="'text'"
                  [placeholder]="'Search'"
                  [(ngModel)]="searchQuery"
                  (keyup.enter)="setSeachQuery()"
                  (blur)="setSeachQuery()"
                  [id]="'tmo-input-default-117'"
                ></tmo-input>
                <span class="search-button">
                  <button (click)="setSeachQuery()" id="btn-default-193">GO!</button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div tmoTitleHeaderSpacing></div>
<tmo-product-reviews
  *ngIf="reviewsStaticContent"
  [scrollEnable]="true"
  [seeAllCta]="seeAllCta"
  [limit]="limit"
  [reviewsStaticContent]="reviewsStaticContent"
  [filterParams]="queryParams"
  [type]="type"
  (filterData)="setFilterData($event)"
>
</tmo-product-reviews>

<div class="row">
  <div class="col-12 buttons-container button-spacing">
    <div class="button-box">
      <button class="btn btn-primary" (click)="goToPDP()" id="btn-default-194">
        {{ reviewsStaticContent?.back }}
      </button>
    </div>
  </div>
</div>
